var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "cargo-advance-search bpm-approval-process",
            staticStyle: {
              width: "100%",
              "margin-top": "5px",
              "min-width": "1280px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-position": "left", "label-width": "120px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "el-form-item-wrapper",
                        staticStyle: { display: "flex" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: {
                                width: "150px",
                                "padding-left": "10px"
                              },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.form.tenantName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "tenantName", $$v)
                                },
                                expression: "form.tenantName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "padding-left": "10px" },
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_IdentifyTheSupplier"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.form.channel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "channel", $$v)
                                  },
                                  expression: "form.channel"
                                }
                              },
                              _vm._l(_vm.CONSIGNMENT_NOTE_PLATFORMS, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$getLangColumn(item),
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "padding-left": "10px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.queryHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Query")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.addHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Add")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.editHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Edit")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: { click: _vm.deleteHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_OrderDelete")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions
              },
              on: {
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.settingDialog.visible,
            title: _vm.$t("CargoMsg.AE_IDENTIFY_VENDORS"),
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.settingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "130px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.TENANT_BUSINESS_NAME") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.TENANT,
                          cache: false,
                          filterable: "",
                          "custom-label": function(item) {
                            return "[" + item.id + "]" + item.name
                          },
                          "callback-method-type": "obj",
                          "default-value":
                            String(_vm.settingDialog.form.tenant) || ""
                        },
                        on: { parentCallBack: _vm.changeTenant }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "padding-bottom": "5px" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editWindowHandler }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_NewTo")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.deleteWindowHandler }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_OrderDelete")) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "750px" },
                    attrs: {
                      "column-defs": _vm.editWindowColumnDefs,
                      "row-data": _vm.editWindow.rowData,
                      "grid-options": _vm.editWindow.gridOptions
                    },
                    on: {
                      gridReady: function(params) {
                        return (_vm.editWindow.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.settingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }